import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-m-2" }
const _hoisted_2 = {
  key: 0,
  class: "p-m-2"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "fa fa-exclamation-triangle p-mr-2" }, null, -1)
const _hoisted_4 = { class: "p-m-2" }
const _hoisted_5 = { class: "p-fluid p-formgrid p-grid p-m-2" }
const _hoisted_6 = { class: "p-field p-col-12" }
const _hoisted_7 = { class: "p-d-flex p-flex-row p-jc-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "p-fluid kn-dialog--toolbar--primary",
    contentStyle: _ctx.documentExecutionLinkDialogDescriptor.dialog.style,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.main.linkToDocument ')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          onClick: _ctx.closeDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        (!_ctx.linkInfo.isPublic)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode("p", null, [
                _hoisted_3,
                _createVNode("span", null, _toDisplayString(_ctx.$t('documentExecution.main.publicUrlExecutionDisabled')), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_4, [
          _createVNode("p", null, _toDisplayString(_ctx.$t('documentExecution.main.copyLinkAndShare')), 1)
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            (_ctx.embedHTML)
              ? (_openBlock(), _createBlock(_component_Textarea, {
                  key: 0,
                  class: "kn-material-input",
                  modelValue: _ctx.publicUrl,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.publicUrl = $event)),
                  rows: 6
                }, null, 8, ["modelValue"]))
              : (_openBlock(), _createBlock(_component_InputText, {
                  key: 1,
                  class: "kn-material-input p-inputtext-sm",
                  modelValue: _ctx.publicUrl,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.publicUrl = $event))
                }, null, 8, ["modelValue"]))
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["contentStyle", "visible"]))
}